import { ICurrencyProps } from '@components/PriceLabel/components/Currency';
import { styled } from '@linaria/react';

import { Line } from '../SelectedVariant/styled';

export const Wrapper = styled.div<{ leftPadding?: boolean }>`
  padding-bottom: 1rem;
  padding-left: ${({ leftPadding }) => (leftPadding ? '0.75rem' : '0')};
`;

export const LabelRow = styled.div`
  display: flex;
  flex-flow: row;
  gap: 0.5rem;

  > span {
    display: flex;
    gap: 0.25rem;
  }
`;

export const PriceWrapper = styled.span<ICurrencyProps>`
  &:before {
    content: ${(props) => (props.isSpaced && !props.isPrefix ? '" "' : '')};
  }
  &:after {
    content: ${(props) => (props.isSpaced && props.isPrefix ? '" "' : '')};
  }
`;

export const WrapperComponent = styled.div`
  margin: 0 !important;
`;

export const LineSeparator = styled(Line)`
  margin-bottom: 0.75rem;
`;

export const DualPriceWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const PriceSplitter = styled.span`
  padding: 0 0.2rem;
`;

export const ConditionalTooltipContent = styled.div`
  min-width: 15rem;
`;
